export enum PaymentTypes {
  PREPAID = 'PREPAID',
  POSTPAID = 'POSTPAID'
}
